// extracted by mini-css-extract-plugin
export default {"section-layout":"SectionLayout_section-layout__f7Ytw","right":"SectionLayout_right__cbzmX","information":"SectionLayout_information__dncS5","image":"SectionLayout_image__Ck5lW"};